import Theme from 'orbiter-web-components/src/components/Theme';

export const ProjectTheme: Theme = {
    font:{
        fontSize:{
            default: '18px',
            h1: '40px',
            h2: '30px',
        },
        lineHeight:{
            default: '22px',
            h1: '50px',
            h2: '35px',
        },
        fontFamily:{
            default: 'Prompt',
            h1: 'Prompt',
            h2: 'Prompt',
        },
    },
    colors: {
        primaryBackground: '#007F85',
        secondaryBackground: 'lightgray',
        primaryText: 'white',
        secondaryText: 'white',
        highlightText: '#FFCC01',
        highlightBackground: '#5B5B5B',
    },
    margin: {
        extraSmallMargin: '5px',
        smallMargin: '10px',
        mediumMargin: '20px',
        largeMargin: '40px',
        extraLargeMargin: '400px',
    },
    padding: {
        extraSmallPadding: '5px',
        smallPadding: '15px',
        mediumPadding: '30px',
        largePadding: '150px',
        extraLargePadding: '400px',
    },
    mobileWidth: {
        maxWidth: '850px',
        minWidth: '851px',
    },
    button: {
        fontWeight: '600',
        fontSize: '1.5rem',
        padding: '0.375rem 1rem',
        backgroundColor: 'white',
        hoverBackgroundColor: 'white',
        activeBackgroundColor: 'white',
        borderColor: 'transparent',
        hoverBorderColor: '#383838',
        activeBorderColor: '#383838',
        textColor: '#282828',
        border: 'none',
        borderRadius: '3px',
        transition: 'color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
    },
    input: {
        fontWeight: '400',
        fontSize: '1rem',
        padding: '0.375rem 0.75rem',
        backgroundColor: 'white',
        hoverBackgroundColor: 'white',
        activeBackgroundColor: 'white',
        borderColor: 'transparent',
        hoverBorderColor: 'transparent',
        activeBorderColor: 'transparent',
        textColor: '#282828',
        border: '1px solid transparent',
        borderRadius: '0.25rem',
        transition: 'color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
    },
    radio: {
        backgroundColor: 'white',
        hoverBackgroundColor: 'white',
        checkedBackgroundColor: '#282828',
        textColor: 'white',
        hoverTextColor: 'white',
        activeTextColor: 'white',
    }
};